<template>
    <div class="card">
        <icon :name="card.img" />
        <div class="card__title">{{ card.title }}<sup v-if="card.sup">{{ card.sup }}</sup></div>
        <p class="card__text">{{ card.text }}</p>
    </div>
</template>

<script>
    import Icon from "./Icon.vue";
    export default {
        name: 'Card',
        components: {
            Icon
        },
        props: {
            card: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import settings
    @import typography
    @import LandingCard
</style>